<template>
  <div class="selectHlyPage">
    <!-- 搜索界面 -->
    <van-search
      v-model="searchKeyword"
      :placeholder="$t('common.nameTip')"
      class="search"
      show-action
      @cancel="onCancel"
    />
    <div
      :class="['pageMain', clientType == 'IOS' ? 'paddB' : '']"
      id="pageMain"
    >
      <van-checkbox-group v-model="result" class="roleMain">
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          finished-text="没有更多了"
        >
          <div class="searchBox">
            <van-cell
              v-for="(item, index) in roleList"
              clickable
              :key="index"
              :title="`${
                item.orgIdName + '-' + item.position + '-' + item.realName
              }`"
              @click="toggle(index, item)"
            >
              <van-checkbox
                :name="`${
                  item.orgIdName + '-' + item.position + '-' + item.realName
                }`"
                ref="checkboxes"
                slot="right-icon"
              />
            </van-cell>
          </div>
        </van-list>
      </van-checkbox-group>
    </div>
    <div class="btnBox clearfix" v-if="this.clientType == 'IOS'">
      <a href="javascript:void(0);" class="closeText" @click="closeText">{{
        $t("common.cancel")
      }}</a>
      <a href="javascript:void(0);" class="addText" @click="addText">{{
        $t("common.save")
      }}</a>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { mapState } from "vuex";
export default {
  name: "selectHly",
  data() {
    return {
      searchKeyword: "", //搜索值
      commentlists: "",
      backstagelists: [],
      applists: [],
      roleList: [], //角色列表
      result: [], //选择的角色列表
      roledata: [], //选中的角色列表
      cloneRoledata: [],
      ItemList: [], //对比数据
      roleId: "", //保存的的角色Id
      commentCount: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      page: 0,
      pageSize: 100,
      contentHeight: 0,
      queryCriteria: "", //搜索关键字
      changeRightType: "",
      changeLeftType: "",
      clientType: getDeviceType(),
      timer: null,
      configType: false, //接口请求 输入框接口请求锁
    };
  },
  props: {
    selecLeftType: { String },
    selecRightType: { String },
  },
  mounted() {
    this.edtiId =
      this.$route.query.commonId == "" ? "" : this.$route.query.commonId;
    this.$nextTick(() => {
      this.selectPage();
    });
  },
  methods: {
    onCancel() {
      this.finished = false;
      this.onSearch();
    },
    selectPage() {
      if (this.userinfo) {
        if (this.edtiId) {
          this.getPageMain();
        }
      } else {
        this.selectPage();
      }
    },
    getPageMain() {
      let _this = this;
      _this.$api.hulin
        .hylDetails(this.edtiId)
        .then((res) => {
          if (res.code == "1") {
            _this.getRole();
            _this.commentlists = res.data.participants;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRole() {
      let _this = this;
      if (_this.configType) {
        //接口正在执行时不继续调用
        return;
      }

      if (_this.page != 0 && this.page * 100 >= parseInt(_this.commentCount)) {
        return;
      }

      _this.page += 1;
      _this.loading = true;
      _this.configType = true;
      _this.$api.hulin
        .sendUserList(_this.page, _this.pageSize, {
          userName: _this.queryCriteria,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.commentCount = parseInt(res.data.total);
            _this.backstagelists = res.data.list;
            _this.viewLists();
            _this.getSource(res.data.list);
            // 加载状态结束
            _this.loading = false;
            if (_this.page * 100 >= _this.commentCount) {
              _this.finished = true;
            }
          } else {
            this.finished = true;
          }
          _this.configType = false;
        })
        .catch((err) => {
          this.finished = true;
          _this.configType = false;
          console.log(err);
        });
    },
    viewLists() {
      this.roleList = this.roleList.concat(this.backstagelists);
    },
    onLoad() {
      this.getRole();
    },
    //编辑传过来参数
    getSource(data) {
      console.log(this.commentlists);
      let newArr = [];
      for (let i = 0; i < this.commentlists.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (this.commentlists[i] == data[j].uid) {
            this.setItemList(data[j]);
          }
        }
      }
    },
    //设置sesstionList
    setItemList(item) {
      let _this = this,
        newArr = [];
      sessionArr = JSON.stringify(newApi.cloneDeep(this.roledata));
      _this.ItemList.push(item);
      sessionStorage.clear();
      _this.roledata.push(item);
      sessionStorage.setItem("sessionarr", sessionArr);
      newArr.push(item.orgIdName + "-" + item.position + "-" + item.realName);
      _this.result = this.result.concat(newArr);
    },
    //人员列表添加
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
      this.roledata.push(this.roleList[index]);
      this.unique(this.roledata);
    },
    //搜索功能
    onSearch() {
      this.queryCriteria = this.searchKeyword;
      this.roleList = [];
      this.commentCount = 0;
      this.page = 0;
      this.getRole();
    },

    addText() {
      let _this = this,
        setData = {},
        arr = [],
        arr1 = [],
        sessionArr = JSON.stringify(newApi.cloneDeep(_this.roledata));
      sessionStorage.clear();

      sessionStorage.setItem("sessionarr", sessionArr);
      _this.roledata.forEach((item) => {
        arr1.push(item.uid);
        arr.push(item.realName);
      });
      setData.count = arr.join("，");
      setData.ids = arr1;
      if (_this.clientType == "android") {
        if (_this.changeRightType == _this.$t("common.save")) {
          _this.$emit("getRoleData", setData);
          _this.changeRightType = "";
        }
      } else {
        _this.$emit("getRoleData", setData);
      }
    },
    closeText() {
      let _this = this;
      let setData = {};
      let NewArr = [];
      let countArr = [];
      let sessionArr = JSON.parse(sessionStorage.getItem("sessionarr")) || [];
      if (sessionArr != []) {
        for (let i = 0; i < sessionArr.length; i++) {
          NewArr.push(
            sessionArr[i].orgIdName +
              "-" +
              sessionArr[i].position +
              "-" +
              sessionArr[i].realName
          );
          countArr.push(sessionArr[i].realName);
        }
        _this.result = NewArr;
      } else {
        _this.result = [];
      }

      setData.count = countArr.join("，");
      if (this.clientType == "android") {
        if (this.changeLeftType == _this.$t("common.cancel")) {
          this.$emit("getRoleData", setData);
          this.changeLeftType = "";
        }
      } else {
        this.$emit("getRoleData", setData);
      }
    },
    unique(dataArray) {
      //数组去重
      let _this = this;
      let removeIndex = [];
      dataArray.forEach((item1, index1) => {
        const exist = dataArray.some(
          (item2, index2) => item1.uid === item2.uid && index1 !== index2
        );
        if (exist) {
          removeIndex.unshift(index1);
        }
      });
      newApi.each(removeIndex, (index) => {
        delete dataArray[index];
      });
      _this.roledata = _this.roledata.filter(function () {
        return true;
      });
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    selecLeftType: function (newValue) {
      this.changeLeftType = String(newValue);
      this.closeText();
    },
    selecRightType: function (newValue) {
      this.changeRightType = String(newValue);
      this.addText();
    },

    searchKeyword() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (this.searchKeyword) {
          this.finished = false;
          this.onSearch();
        }
      }, 2000);
    },
  },
};
</script>
<style lang="less">
.selectHlyPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  position: relative;

  .search {
    width: 100%;
    height: 7%;
  }
  .pageMain {
    width: 100%;
    height: 93%;
    overflow-y: scroll;
    box-sizing: border-box;
  }
  .pageMain.paddB {
    padding-bottom: 45px;
  }
  .btnBox {
    width: 100%;
    height: 45px;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    border-top: 1px solid #f3f3f3;
    a {
      display: inline-block;
      width: 50%;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
      box-sizing: border-box;
      text-align: center;
    }
    a.closeText {
      border-right: 1px solid #f6f6f6;
      color: #666;
    }
    a.addText {
      color: #36c376;
    }
  }
}
</style>